import React from 'react';
import { StaffPicksCardImage } from './cards/StaffPicksCardImage';
import Style from './css/AllArticles.module.css';
import { FormattedMessage } from 'react-intl';

const AllArticles = ({ blogData, allArticlesTextTitle }) => {
  return (
    <div className={Style.container}>
      <div className={Style.title_container}>
        <FormattedMessage id={allArticlesTextTitle ? allArticlesTextTitle : 'Todos'} />
      </div>

      {blogData?.map((item, index) => (
        <StaffPicksCardImage key={index} cardData={item} />
      ))}
    </div>
  );
};

export default AllArticles;
